import type { AssetGenerationDto } from '@reelplicate/api-client/model';
import type { VideoFormat, VideoModel, VideoQuality } from '@reelplicate/flows';

import type { ReplicateRequest } from './replicate-scene-modal';

/** What a remade video is made again from: its saved settings and prompts. */
export function makeAgainRequest(g: AssetGenerationDto): Partial<ReplicateRequest> {
  return {
    videoModel: g.videoModel as VideoModel | undefined,
    format: g.format as VideoFormat | undefined,
    quality: g.quality as VideoQuality | undefined,
    durationSeconds: g.durationSeconds === 10 ? 10 : 5,
    framePrompt: g.framePrompt,
    prompt: g.prompt,
  };
}
